<template>
    <a-modal v-model="visible" title="项目曾获奖励情况明细" width="67%" centered :maskClosable="false" :keyboard="false" class="diyModelCls">
        <a-spin :spinning="loading">
            <vxe-toolbar size="mini">
                <template v-slot:tools>
                    <a-button type="primary" :loading="saving || loading" @click="insertItem" style="margin-right:10px">新增</a-button>
                </template>
            </vxe-toolbar>
            <vxe-table
                ref="itemTable"
                size="mini"
                resizable
                keep-source
                auto-resize
                row-id="id"
                align="left"
                header-align="center"
                highlight-hover-row
                show-overflow="tooltip"
                :data="editItemData"
                :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
            >
                <vxe-table-column
                    type="seq"
                    title="序号"
                    width="70"
                    align="center"
                    :edit-render="{
                        type: 'default',
                        autofocus: 'input'
                    }"
                >
                    <template v-slot:edit="scope">
                        <a-input size="small" v-model="scope.row.xh" />
                    </template>
                </vxe-table-column>
                <vxe-table-column
                    :edit-render="{
                        type: 'default',
                        autofocus: 'input'
                    }"
                    field="hjsj"
                    title="获奖时间"
                    width="150"
                    header-class-name="required"
                    align="center"
                >
                    <template v-slot:edit="scope">
                        <a-date-picker ref="hjsj" v-model="scope.row.hjsj" width="100%" valueFormat="YYYY-MM-DD" style="width:100%" />
                    </template>
                </vxe-table-column>
                <vxe-table-column
                    :edit-render="{
                        type: 'default',
                        autofocus: 'input'
                    }"
                    field="jlmc"
                    title="奖励名称"
                    width="300"
                    header-class-name="required"
                >
                    <template v-slot:edit="scope">
                        <a-input size="small" v-model="scope.row.jlmc" :maxLength="50" />
                    </template>
                </vxe-table-column>
                <vxe-table-column
                    :edit-render="{
                        type: 'default',
                        autofocus: 'input'
                    }"
                    field="jldj"
                    title="等级"
                    width="120"
                    header-class-name="required"
                    align="center"
                >
                    <template v-slot:edit="scope">
                        <a-input size="small" v-model="scope.row.jldj" :maxLength="10" />
                    </template>
                </vxe-table-column>
                <vxe-table-column
                    field="jjse"
                    title="奖金数额(元)"
                    width="110"
                    header-align="center"
                    align="right"
                    :edit-render="{ type: 'default', autofocus: 'input' }"
                >
                    <template v-slot:edit="scope">
                        <a-input-number size="small" v-model="scope.row.jjse" :precision="2" />
                    </template>
                    <template v-slot="{ row }">
                        <span> {{ $FG_util.formatNumber(row.jjse, "0.00") }} </span>
                    </template>
                </vxe-table-column>
                <vxe-table-column
                    :edit-render="{
                        type: 'default',
                        autofocus: 'input'
                    }"
                    field="sjbm"
                    title="授奖部门"
                    min-width="100"
                >
                    <template v-slot:edit="scope">
                        <a-input size="small" v-model="scope.row.sjbm" :maxLength="100" />
                    </template>
                </vxe-table-column>
                <vxe-table-column title="附件" width="150" align="center">
                    <template v-slot="scope">
                        <span class="btn_edit" @click="attachInsert(scope.row)">上传相关材料</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column title="操作" width="70" align="center">
                    <template v-slot="scope">
                        <span class="btn_edit" @click="removeItem(scope.row)">删除</span>
                    </template>
                </vxe-table-column>
            </vxe-table>
        </a-spin>
        <template v-slot:footer>
            <a-button @click="onClose" style="margin-right:8px;">
                取消
            </a-button>
            <a-button type="primary" :loading="saving || loading" @click="onSave">
                保存
            </a-button>
        </template>
        <AttachModalUpload :attachCfg.sync="attachProps" />
    </a-modal>
</template>

<script>
export default {
    name: "HjqkmxEdit",
    props: ["showHjqkmxEdit", "dataId", "cgsbbmxid"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 编辑数据
            editData: {},
            editItemData: [],
            editDataLoading: false,
            editProps: {
                showHjqkmxEdit: false,
                cgsbbmxid: null
            },
            attachProps: {
                visible: false,
                fkvalue: null,
                fktable: "CG_CGSBBMX_HJQK",
                fkfield: "ID",
                attachSource: "CG1001"
            }
        };
    },
    computed: {
        visible: {
            get() {
                return this.showHjqkmxEdit;
            },
            set(newVal) {
                this.$emit("update:showHjqkmxEdit", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        }
    },
    watch: {
        visible: {
            handler(newVal) {
                // 显示编辑窗口时加载数据
                if (newVal) {
                    // 修改，加载数据
                    this.loadItemData();
                }
            },
            immediate: true
        }
    },
    methods: {
        loadItemData() {
            this.editItemData = [];
            this.editItemDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgsbgl/listItemHjqkmx",
                    {
                        cgsbbmxid: this.cgsbbmxid,
                        sort: {
                            field: "XH",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataLoading = false;
                    if (success) {
                        this.editItemData = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 取消
        onClose(e) {
            this.visible = false;
        },
        // 新增
        insertItem() {
            // 设置编辑记录
            let xh = this.$refs.itemTable.getTableData().tableData.length + 1;
            this.$refs.itemTable
                .insertAt(
                    {
                        isnew: true,
                        id: this.$FG_util.uuid(),
                        cgsbbid: this.dataId,
                        cgsbbmxid: this.cgsbbmxid,
                        xh: xh
                    },
                    -1
                )
                .then(({ row }) => {
                    this.$refs.itemTable.setActiveRow(row);
                });
        },
        // 删除
        removeItem(row) {
            this.$FG_message.confirm("P0000", "删除").then((type) => {
                if (type === "ok") {
                    if (row.isnew === true) {
                        this.$refs.itemTable.remove(row);
                    } else {
                        this.editDataLoading = true;
                        this.$FG_http
                            .post("./api/main/zxcggl/cgsbgl/deleteHjqkmx", {
                                id: row.id
                            })
                            .then(({ success, data, errMsg }) => {
                                this.editDataLoading = false;
                                if (success) {
                                    this.loadItemData();
                                }
                            });
                    }
                }
            });
        },
        //保存
        onSave() {
            let itemData = this.$refs.itemTable.getInsertRecords().concat(this.$refs.itemTable.getUpdateRecords());
            for (let i = 0; i < itemData.length; i++) {
                if (!itemData[i].hjsj) {
                    this.$FG_message.error("P0001", "获奖时间").then(() => {
                        this.$refs.itemTable.setActiveRow(itemData[i]);
                    });
                    return;
                }
                if (!itemData[i].jlmc) {
                    this.$FG_message.error("P0001", "奖励名称").then(() => {
                        this.$refs.itemTable.setActiveRow(itemData[i]);
                    });
                    return;
                }
                if (!itemData[i].jldj) {
                    this.$FG_message.error("P0001", "等级").then(() => {
                        this.$refs.itemTable.setActiveRow(itemData[i]);
                    });
                    return;
                }
            }
            // 保存操作
            this.saving = true;
            this.$FG_http
                .post("./api/main/zxcggl/cgsbgl/saveHJQKMX", {
                    itemData
                })
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        // 返回列表
                        this.visible = false;
                        // 通知父组件数据已更新
                        this.$emit("dataUpdated", this.dataId);
                    } else {
                        this.$refs.jlmc.focus();
                    }
                });
        },
        // 附件管理
        attachInsert(row) {
            // 设置编辑记录id
            this.attachProps.fkvalue = row.id;
            // 显示编辑窗口
            this.attachProps.visible = true;
        }
    }
};
</script>
